import _ from "lodash";
import React, { PureComponent } from "react";
import BenchmarkView from "UIComponents/BenchmarkView";
import Accordian from "UIComponents/Accordian";
import I18nHOC from "UIComponents/I18nHOC";
import { getElementValue } from "modules/ElementValueUtils";
import { CURRICULUM_TYPE_PYP } from "Constants/stringConstants";
import classes from "./SubjectBenchmarks.scss";

const getElementValueMemoize = _.memoize(getElementValue, params =>
  JSON.stringify(params)
);

const styles = {
  nodeLabelStyle: [
    {
      depth: 3,
      style: {
        marginBottom: "12px",
      },
    },
  ],
};

class SubjectBenchmarks extends PureComponent {
  state = {
    selectedValues: this.props.selectedValues,
  };

  debouncedOnItemSelected = _.debounce(
    params => this.props.onItemSelected(params),
    100
  );

  componentDidUpdate = prevProps => {
    const { selectedValues } = this.props;
    if (!_.isEqual(prevProps.selectedValues, selectedValues)) {
      this.setState({ selectedValues });
    }
  };

  onCheckboxClicked = selectedValues => {
    const {
      props: { subject, nodes, rootNodes },
    } = this;

    this.setState({ selectedValues }, () => {
      this.debouncedOnItemSelected({
        subject,
        selections: selectedValues,
        nodes,
        rootNodes,
      });
    });
  };

  getExpandedContent = ({ elementValue }) => {
    const {
      props: {
        isReverseCheckbox,
        checkboxItemStyle,
        nodeSpanStyle,
        checkboxContainerStyle,
      },
      state: { selectedValues },
    } = this;

    return (
      <BenchmarkView
        value={elementValue}
        startDepth={1}
        mode={"view"}
        isTagging={true}
        updateInputField={this.onCheckboxClicked}
        selectedValues={selectedValues}
        isReverseCheckbox={isReverseCheckbox}
        checkboxItemStyle={checkboxItemStyle}
        nodeSpanStyle={nodeSpanStyle}
        nodeLabelStyle={styles.nodeLabelStyle}
        checkboxContainerStyle={checkboxContainerStyle}
      />
    );
  };

  render() {
    const {
      props: {
        subject,
        nodes,
        rootNodes,
        showAccordian,
        hideContainerBorder,
        showLabelBorder,
        showCountSeperate,
        customTitleStyle,
        isExpanded,
        fieldUID,
        showCountBadge,
        t,
        curriculumType,
      },
      state: { selectedValues },
    } = this;

    const elementValue = _.compact(
      getElementValueMemoize({
        valueKeys: _.map(nodes, node => node.id),
        fieldUID: fieldUID,
        benchmarkSet: { nodes, rootNodes },
      })
    );

    const numOfSelectedValues = _.get(selectedValues, "length", 0);
    const selectedNumberString =
      numOfSelectedValues > 0 && !showCountSeperate
        ? ` (${numOfSelectedValues})`
        : "";

    const isArchived =
      curriculumType === CURRICULUM_TYPE_PYP
        ? _.get(subject, "value.resolvedSubject.isArchived", false)
        : _.get(subject, "value.isArchived", false);

    const title = (
      <div className={classes.titleText}>
        {`${subject.label}${selectedNumberString}`}
        {isArchived ? (
          <div className={classes.archivedText}>{`(${t(
            "common:archived"
          )})`}</div>
        ) : null}
      </div>
    );

    if (showAccordian)
      return (
        <Accordian
          title={title}
          getExpandedContent={() => this.getExpandedContent({ elementValue })}
          hideContainerBorder={hideContainerBorder}
          showLabelBorder={showLabelBorder}
          count={showCountSeperate ? numOfSelectedValues : 0}
          customTitleStyle={customTitleStyle}
          isExpanded={isExpanded}
          showCountBadge={showCountBadge}
        />
      );

    if (!_.isEmpty(elementValue))
      return (
        <div className={classes.onSearchSectionContainer}>
          <div className={classes.onSearchSectionSubHeader}>
            <span
              dangerouslySetInnerHTML={{
                __html: subject.label,
              }}
            />
          </div>
          <div className={classes.onSearchExpandedContainer}>
            {this.getExpandedContent({ elementValue })}
          </div>
          <div className={classes.dividerNew} />
        </div>
      );

    return null;
  }
}

SubjectBenchmarks.defaultProps = {
  isReverseCheckbox: false,
  searchTerm: "",
  hideContainerBorder: false,
  showLabelBorder: true,
  showCountSeperate: false,
  checkboxItemStyle: {},
  customTitleStyle: {},
  nodeSpanStyle: {},
  isExpanded: false,
  showAccordian: true,
  fieldUID: "benchmarks",
  checkboxContainerStyle: {},
  showCountBadge: false,
};

export default I18nHOC({ resource: ["common"] })(SubjectBenchmarks);
